import type { AwardTier } from '@shared/seasons';
import { awardMedallion, awardTierKey, type AwardState } from './seasonAwardVisuals';

/**
 * A single placement badge: a coloured medallion (crown for Champion, else the
 * "Top N" cut-off) with its label. `state` drives the emphasis — the tier
 * you'll get glows, the next goal pulses.
 */
export function SeasonAwardBadge({
  tier,
  state,
  size = 'md',
}: {
  tier: AwardTier;
  state: AwardState;
  size?: 'sm' | 'md';
}) {
  return (
    <div
      className={`season-award season-award-${awardTierKey(tier.threshold)} is-${state} season-award-${size}`}
      title={`${tier.label}${state === 'next' ? ' — your next goal' : ''}`}
    >
      <span className="season-award-medallion" aria-hidden="true">
        {awardMedallion(tier)}
      </span>
      <span className="season-award-label">{tier.label}</span>
    </div>
  );
}
